if (
  typeof Number !== undefined
  && Number.prototype
  && !Number.prototype.countDecimals
) {
  Object.defineProperty(Number.prototype, 'countDecimals', {
    value() {
      if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
      return this.toString().split('.')[1].length || 0;
    }
  });
}